import { SamlAccountConnectionResource } from '@clerk/types';

export enum UserType {
  Anonymous = 'anonymous',
  Enterprise = 'enterprise',
  Employee = 'employee',
  Consumer = 'consumer',
}

export type ClerkInviteResponse = {
  error: boolean;
  clerk_id?: string;
  message: string;
};

export type ClerkSigninTokenResponse = {
  error: boolean;
  token?: string;
  message: string;
};

// response from Section platform backend
export type SectionUserResponse = {
  email: string;
  user_id: string;
  display_name?: string;
  company?: string;
};

type InviteJsonBody = {
  text?: string;
  email?: string;
};

export type InviteJsonResponse = {
  status: number;
  body?: InviteJsonBody;
};

export type SAMLLookupRequestBody = {
  email: string;
};

export type SAMLLookupOptions = {
  email?: string;
};

export type SAMLLookupResponse = {
  error: boolean;
  message: string;
  saml_connections?: SamlAccountConnectionResource[];
};

type SamlLookupJsonBody = {
  domain?: string;
  email?: string;
  responseType?: string;
  text?: string;
};

export type SamlLookupJsonResponse = {
  status: number;
  body?: SamlLookupJsonBody;
};

export const SectionEmailDomains: string[] = [
  'section4.com',
  'machineandpartners.com',
  'sectionschool.com',
  'sectionai.com',
];

export type UserCustomer = {
  id: string;
  name: string;
};
